<template>
  <div class="credits-badge">
    <span class="badge rounded-pill" :class="badgeClass">
      {{ translate('app.credits', 'Credits') }}: {{ credits }}
      <span v-if="demo === 1" class="demo-indicator">{{ translate('app.demo', 'DEMO') }}</span>
    </span>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'CreditsBadge',
  setup() {
    const store = useStore()
    
    const credits = computed(() => store.state.credits || 0)
    const demo = computed(() => store.state.demo)
    
    // Determinar el color del badge según la cantidad de créditos
    const badgeClass = computed(() => {
      if (credits.value > 5) return 'bg-success'
      if (credits.value > 2) return 'bg-warning'
      return 'bg-danger'
    })
    
    const translate = (key, fallback) => {
      return store.getters.translate(key, fallback)
    }
    
    return {
      credits,
      demo,
      badgeClass,
      translate
    }
  }
}
</script>

<style scoped>
.credits-badge {
  margin-right: 15px;
}

.badge {
  font-size: 0.9rem;
  padding: 0.4rem 0.8rem;
}

.demo-indicator {
  font-size: 0.7rem;
  display: inline-block;
  padding: 0.15rem 0.4rem;
  margin-left: 5px;
  background-color: #6c757d;
  border-radius: 3px;
  vertical-align: middle;
}
</style>
